import { combineReducers } from "redux";
import accountReducer from "../components/domain/accounts/accountReducer";
import employeeReducer from "../components/domain/employee/employeeReducer";
import UsersList from "../components/domain/employee/employeeReducer";
import departmentReducer from "../components/domain/department/departmentReducer";
import employmentTypeReducer from "../components/domain/employmentType/employmentTypeReducer";
import designationReducer from "../components/domain/designation/designationReducer";
import projectReducer from "../components/domain/project/projectReducer";
import teamReducer from "../components/domain/team/teamReducer";
import employeeSkillsReducer from "../components/domain/employee/skills/employeeSkillsReducer";
import companyReducer from "../components/domain/company/companyReducer";
import officeReducer from "../components/domain/company/companyOffices/officeReducer";
import salaryHistoryReducer from "../components/domain/salaryHistory/salaryHistoryReducer";
import pagingReducer from "../components/common/pagination/pagingReducer";
import timeOffReducer from "../components/domain/timeOff/timeOffReducer";
import leaveApprovalReducer from "../components/domain/leaveApproval/leaveApprovalReducer";
import notificationReducer from "../components/domain/notifications/notificationReducer";

import { reducer as toastrReducer } from "react-redux-toastr";
import userReducer from "../components/domain/users/userReducer";
import leaveTypeReducer from "../components/common/header/settings/leaveTypes/leaveTypeReducer";
import settingsReducer from "../components/common/header/settings/settingsReducer";
import attendanceReducer from "../components/domain/attendance/attendanceReducer";
export default combineReducers({
  accountReducer: accountReducer,
  toastr: toastrReducer,
  companyReducer: companyReducer,
  officeReducer: officeReducer,
  employeeReducer: employeeReducer,
  employeeSkills: employeeSkillsReducer,
  salaryHistoryReducer: salaryHistoryReducer,
  departmentReducer: departmentReducer,
  employmentTypeReducer: employmentTypeReducer,
  designationReducer: designationReducer,
  projectReducer: projectReducer,
  teamReducer: teamReducer,
  UsrList: UsersList,
  pagingReducer: pagingReducer,
  timeOffReducer: timeOffReducer,
  userReducer: userReducer,
  leaveTypeReducer: leaveTypeReducer,
  leaveApprovalReducer: leaveApprovalReducer,
  notificationReducer: notificationReducer,
  settingsReducer: settingsReducer,
  attendanceReducer: attendanceReducer,
});
